import { User } from "@/types/Users";
import UserActionBlock from "./UserActionBlock";
import UserActionModal from "@/components/Modals/UserActionModal";
import { FC, useState } from "react";
import { useSnackbar } from "notistack";
import { usePermissions } from "@/hooks/usePermissions";
import LoggingAPI from "@/api/logging";
import { userApi } from "@/api";

interface ResetUserMFABlockProps {
  userData: User;
  onSubmit: () => void;
}

const ResetUserMFABlock: FC<ResetUserMFABlockProps> = ({
  userData,
  onSubmit,
}) => {
  const { currentUser } = usePermissions();
  const { enqueueSnackbar } = useSnackbar();

  const [showResetMFAModal, setShowResetMFAModal] = useState(false);

  const handleSubmit = async () => {
    if (!userData?.email) {
      enqueueSnackbar("An error occurred resetting user MFA: invalid email.", {
        variant: "error",
      });
      console.log("An error occurred resetting user MFA: invalid email.");
      return;
    }
    userApi.resetMFA({
      email: userData?.email,
    });
    enqueueSnackbar("User MFA has been reset.", {
      variant: "success",
    });

    LoggingAPI.createLog({
      user_id: currentUser.user_id,
      message: `MFA Device removed: ${userData?.email}`,
      event: "user:reset_mfa",
      object_type: "user",
    });
    onSubmit();
  };

  return (
    <>
      <UserActionBlock
        title="Reset MFA"
        tooltip="Remove current MFA device from user's account."
        buttonProps={{
          primaryText: "Reset MFA",
          action: () => setShowResetMFAModal(true),
        }}
      />
      <UserActionModal
        show={showResetMFAModal}
        onCancel={() => setShowResetMFAModal(false)}
        onClose={() => setShowResetMFAModal(false)}
        onSubmit={handleSubmit}
        title="Reset MFA Device"
        body="The user will be prompted to connect a new device at their next login."
        buttonProps={{
          submitText: "Reset MFA",
        }}
      />
    </>
  );
};

export default ResetUserMFABlock;
